import React, {FC, useMemo} from 'react';
import {useAppSelector} from "../../../store/hooks";
import WikiIcon from "../../common/icons/WikiIcon";
import PlusIcon from "../../common/icons/PlusIcon";
import {isEmail} from "../../../utils/convert";
import {TPageResponse, wikiAPI} from "../../../api/wp";
import {pageAPI} from "../../../api/page";
import {useNavigate} from "react-router-dom";

const MainHeader: FC = () => {
    const navigate = useNavigate()
    const page = useAppSelector(state => state.search.page)
    const commonOptions = useAppSelector(state => state.common.options)
    const userOptions = useAppSelector(state => state.user.options)
    const authUser = useAppSelector(state => state.auth.authUser)
    const [checkRedirect, {data: redirect, isLoading: isRedirectLoading, isSuccess: isRedirectSuccess}] = wikiAPI.useCheckRedirectMutation()
    const [addPage, {}] = pageAPI.useAddMutation()

    const {data: pages} = pageAPI.useGetAllQuery({
        sort: commonOptions.tracingSortingField,
        order: commonOptions.tracingSortingType as "desc" | "asc",
        email: commonOptions.tracingFilterEmail ?? ''
    })

    if (!page || !userOptions) return <></>

    const isPageTraced = () => {
        if (!pages) return false;
        for (let p of pages) {
            if (page.id && +p.commonId === +page.id) return true;
        }

        return false;
    }

    const addPageHandler = async () => {
        if (!window.confirm("Do you really want to trace this page?")) return;

        navigate('/tracing')

        let {data: pagesData} = await checkRedirect({
            titles: [page.title, `Talk:${page.title}`],
            withRedirect: true
        })
        if (!pagesData || !pagesData.page) return;
        if (!authUser) return;

        let pageData: TPageResponse | undefined = pagesData.page
        if (!pageData) return;

        if (pageData.redirectedFrom) {
            if (window.confirm('Want to trace redirected page?')) {
                let data = await checkRedirect({
                    titles: [pageData.redirectedFrom, `Talk:${pageData.redirectedFrom}`],
                    withRedirect: false
                })
                pagesData = data?.data
                pageData = pagesData?.page
                if (!pageData) return;
            }
        }

        const email = (commonOptions.tracingEmail && isEmail(commonOptions.tracingEmail))
            ? commonOptions.tracingEmail
            : authUser.email

        const skipInitialMessage = !!userOptions.skipInitialMessage

        await addPage({
            id: pageData.id,
            title: pageData.title,
            url: pageData.url ?? '',
            email: email,
            skip: skipInitialMessage,
            revision: pageData.lastRevisionId ?? 0
        })

        if (!userOptions.addTalkPage) return;

        const talkPageData = pagesData?.talk
        if (!talkPageData) return;

        await addPage({
            id: talkPageData.id,
            title: talkPageData.title,
            url: talkPageData.url ?? '',
            email: email,
            skip: skipInitialMessage,
            revision: talkPageData.lastRevisionId ?? 0
        })
    }

    return (
        <section className="mt-[30px] mb-[30px] md:mt-[50px] md:mb-[50px]">
            <div className="container">
                <div className="flex items-center">
                    <h1 className="text-2xl md:text-4xl font-extrabold mr-3">
                        {page.redirectedFrom ? `Redirect: ${page.redirectedFrom} -> ${page.title}` : page.title}
                    </h1>
                    {page.url && <a href={page.url} target="_blank" className="hover:opacity-70 mr-2">
                        <WikiIcon />
                    </a>}
                    {!isPageTraced() && <span className="inline-block cursor-pointer" onClick={addPageHandler}>
                        <PlusIcon width={33} height={33} />
                    </span>}
                </div>
            </div>
        </section>
    );
};

export default MainHeader;